import * as tslib_1 from "tslib";
import { processAttachmentPreviewsForItems, processAttachmentPreviewsForConversations, } from './processAttachmentsForRow';
import getAttachmentPreviews from '../services/getAttachmentPreviews';
import { action, select } from 'satcheljs/lib/legacy';
import { listViewStore } from 'owa-mail-list-store';
import { mailStore } from 'owa-mail-store';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
/**
 * List to store the conversation Ids to get the attachment previews for
 */
var rowIdsToGetPreviewsMap = new Map(); // Map<groupSmtp, RowIdsToGetPreviews>
/**
 * Adds the conversationId to the fetch list
 * @param mailboxInfo associated with the table to which the rows belongs
 * @param conversationId which needs to be added to the fetch list.
 * @param itemId itemId of the row for which to fetch the previews using its conversation id
 */
export var add = select({
    rowIdsToGetPreviewsMap: function () { return rowIdsToGetPreviewsMap; },
})(action('AttachmentPreviewsOperations.add')(function add(mailboxInfo, conversationId, itemId, state) {
    var rowIdsToGetPreviewsFor = state.rowIdsToGetPreviewsMap[mailboxInfo && mailboxInfo.mailboxId];
    // Create entry for the rowIds if it does not exist
    if (!rowIdsToGetPreviewsFor) {
        rowIdsToGetPreviewsFor = {
            conversationsIdsArray: [],
            itemIdsArray: [],
        };
        state.rowIdsToGetPreviewsMap[mailboxInfo && mailboxInfo.mailboxId] = rowIdsToGetPreviewsFor;
    }
    // Add conversationId to the fetch list if it does not exist
    if (rowIdsToGetPreviewsFor.conversationsIdsArray.indexOf(conversationId) == -1) {
        rowIdsToGetPreviewsFor.conversationsIdsArray.push(conversationId);
    }
    // Add itemId to the fetch list if it does not exist
    if (rowIdsToGetPreviewsFor.itemIdsArray.indexOf(itemId) == -1) {
        rowIdsToGetPreviewsFor.itemIdsArray.push(itemId);
    }
}));
/**
 * Makes a call to getAttachmentPreviews
 */
export var getPreviews = select({
    rowIdsToGetPreviewsMap: function () { return rowIdsToGetPreviewsMap; },
})(action('AttachmentPreviewsOperations.getPreviews')(function getPreviews(mailboxInfo, listViewType, state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var rowIdsToGetPreviews, conversationIds, itemIds, shouldIncludeInlineImages, response, error_1;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    rowIdsToGetPreviews = state.rowIdsToGetPreviewsMap[mailboxInfo && mailboxInfo.mailboxId];
                    // Early return if we do not have any entry for in the fetch list
                    if (!rowIdsToGetPreviews) {
                        return [2 /*return*/];
                    }
                    conversationIds = rowIdsToGetPreviews.conversationsIdsArray;
                    itemIds = rowIdsToGetPreviews.itemIdsArray;
                    shouldIncludeInlineImages = isConsumer();
                    // Clear the entry
                    delete state.rowIdsToGetPreviewsMap[mailboxInfo && mailboxInfo.mailboxId];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getAttachmentPreviews(conversationIds, mailboxInfo && mailboxInfo.requestOptions, {
                            IncludeInlineAttachments: shouldIncludeInlineImages,
                        })];
                case 2:
                    response = _a.sent();
                    if (response.Conversations !== undefined) {
                        if (listViewType == 1 /* Message */) {
                            processAttachmentPreviewsForItems(response.Conversations, itemIds, mailboxInfo);
                        }
                        else {
                            processAttachmentPreviewsForConversations(response.Conversations, mailboxInfo);
                        }
                    }
                    else {
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    handleGetAttachmentPreviewsFail(listViewType, itemIds, conversationIds);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}));
/**
 * Handle the getAttachmentPreview call failure
 * @param listViewType the type of the list view
 * @param itemIds the itemIds if this is for the message view
 * @param conversationIds the ids of the conversations if this is for conversation view
 */
function handleGetAttachmentPreviewsFail(listViewType, itemIds, conversationIds) {
    if (listViewType == 1 /* Message */) {
        itemIds.forEach(function (itemId) {
            var clientItem = mailStore.items.get(itemId);
            // If the message has already been deleted, no clean up is necessary
            if (!clientItem) {
                return;
            }
            // Check if we are already showing previews for this row, if we are then we do not want to hide them.
            // Else we want to hide the space alloacated for the previews as the call to get the previews failed.
            var attachmentPreviewWellViewState = listViewStore.rowAttachmentPreviewWellViews.get(itemId);
            if (!attachmentPreviewWellViewState) {
                clientItem.shouldShowAttachmentPreviews = false;
            }
        });
    }
    else {
        conversationIds.forEach(function (conversationId) {
            var convId = conversationId.Id;
            var conversationItem = listViewStore.conversationItems.get(convId);
            // If the converation has already been deleted, no clean up is necessary
            if (!conversationItem) {
                return;
            }
            // Check if we are already showing previews for this row, if we are then we do not want to hide them.
            // Else we want to hide the space alloacated for the previews as the call to get the previews failed.
            var attachmentPreviewWellViewState = listViewStore.rowAttachmentPreviewWellViews.get(convId);
            if (!attachmentPreviewWellViewState) {
                conversationItem.shouldShowAttachmentPreviews = false;
            }
        });
    }
}
/**
 * Makes a call to getAttachmentPreviews. This is currently used in the conversation well in the reading pane
 */
export var getAttachmentsForConversationWell = action('AttachmentPreviewsOperations.getAttachmentsForConversationWell')(function getAttachmentsForConversationWell(conversationId) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var conversationIds, attachmentTypes, parentItemIdMap, itemReceivedTimeMap, response, error_2;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    conversationIds = [conversationId];
                    attachmentTypes = [];
                    parentItemIdMap = {};
                    itemReceivedTimeMap = {};
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, getAttachmentPreviews(conversationIds, conversationId.mailboxInfo && conversationId.mailboxInfo.requestOptions, {
                            FullPreviewsPerConversation: 300,
                            PreviewsPerConversation: 300,
                            MinimumAttachmentSize: 0,
                            IncludeInlineAttachments: false,
                        })];
                case 2:
                    response = _a.sent();
                    if (response.Conversations !== undefined) {
                        response.Conversations.forEach(function (conversation) {
                            if (conversation.ConversationId.Id == conversationId.Id &&
                                conversation.AttachmentPreviews &&
                                conversation.AttachmentPreviews.Previews) {
                                conversation.AttachmentPreviews.Previews.forEach(function (preview) {
                                    attachmentTypes.push(preview.Attachment);
                                    parentItemIdMap[preview.Attachment.AttachmentId.Id] = tslib_1.__assign({}, preview.ParentItemId, { mailboxInfo: conversationId.mailboxInfo });
                                    itemReceivedTimeMap[preview.Attachment.AttachmentId.Id] =
                                        preview.ItemReceivedTime;
                                });
                            }
                        });
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/, [attachmentTypes, parentItemIdMap, itemReceivedTimeMap]];
            }
        });
    });
});
//# sourceMappingURL=attachmentPreviewOperations.js.map